import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Actions, ofType } from '@ngrx/effects';
import { DialogAnimationService } from 'src/app/angular-core/services/dialog-animation.service';
import { DeviceSubscriptionOfferExt } from 'src/app/generated/CrossPoint.License.Server';
import { BasicXpacInfo } from 'src/app/generated/CrossPoint.RemoteXpac.Server';
import { DevicesActionsTypes } from 'src/app/store/actions/devices.actions';

export interface RemoteMaintenanceItemInfoData {
  xpac: BasicXpacInfo;
}

@UntilDestroy()
@Component({
  selector: 'xpac-remote-maintenance-item-info',
  templateUrl: './remote-maintenance-item-info.component.html',
  styleUrls: ['./remote-maintenance-item-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemoteMaintenanceItemInfoComponent implements OnInit {

  public storeLicense: DeviceSubscriptionOfferExt[] = [];

  constructor(public dialogRef: MatDialogRef<RemoteMaintenanceItemInfoComponent>,
    public dialog: DialogAnimationService,
    private actionsListener$: Actions,
    @Inject(MAT_DIALOG_DATA) public data: RemoteMaintenanceItemInfoData) { }

  public ngOnInit(): void {
    this.onInitListners();
  }

  public onNoClick(): void {
    this.dialogRef.close(true);
  }

  public getHeader(): string {
    let header: string = "";
    if (this.data.xpac.storeName) {
      header = this.data.xpac.storeName;
    }
    else {
      header = this.data.xpac.deviceId;
    }

    return header;
  }

  private onInitListners(): void {

    this.actionsListener$
      .pipe(ofType(DevicesActionsTypes.DELETE_DEVICE_SUCCESS))
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.dialogRef.close(true);
      });
  }
}
